<template>
  <div class="d-flex flex-grow-1 flex-column">
    <div class="p-4">
      <el-tabs v-model="query.area" @tab-click="handleTabClick">
        <el-tab-pane label="省市州" name="city" v-if="auth.user.role === 'province'">
          <el-row class="mb-2">
            <el-button type="primary" @click="handleAdd"><i class="el-icon-plus" />新增</el-button>
            <el-cascader
              v-model="query.city"
              placeholder="请选择地区搜索"
              clearable
              :options="options.map(_option => {
                return {value: _option.value, label: _option.label}
              })"
              @change="handleQueryCityChange"
            />
          </el-row>
          <el-table :key="timer" border :data="tableData" :row-class-name="tableRowClassName">
            <el-table-column
              prop="nickname"
              width="200"
              label="名称"
            />
            <el-table-column
              prop="username"
              label="用户名"
            />
            <el-table-column
              prop="area"
              label="区域"
            />

            <el-table-column
              prop="created_at"
              width="180"
              label="添加时间"
            />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button type="text" @click="handleStatus(scope.row)">{{ scope.row.block === 1 ? '启用' : '禁用' }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="query.page"
            :page-size="20"
            layout="total, prev, pager, next"
            :total="total"
            @current-change="getUsers"
          />
        </el-tab-pane>
        <el-tab-pane label="区县" name="district" v-if="auth.user.role === 'province' || auth.user.role === 'city'">
          <el-row class="mb-2">
            <el-button type="primary" @click="handleAdd"  v-if="auth.user.role === 'province'"><i class="el-icon-plus" />新增</el-button>
            <el-cascader
              v-if="auth.user.role === 'province'"
              v-model="query.city"
              placeholder="请选择地区搜索"
              clearable
              :options="options.map(_option => {
                return {value: _option.value, label: _option.label}
              })"
              @change="handleQueryCityChange"
            />
          </el-row>
          <el-table :key="timer" border :data="tableData">
            <el-table-column
              prop="nickname"
              width="200"
              label="名称"
            />
            <el-table-column
              prop="username"
              label="用户名"
            />
            <el-table-column
              prop="area"
              label="区域"
            />

            <el-table-column
              prop="created_at"
              width="180"
              label="添加时间"
            />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button type="text" @click="handleStatus(scope.row)">{{ scope.row.status === 1 ? '启用' : '禁用' }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="query.page"
            :page-size="20"
            layout="total, prev, pager, next"
            :total="total"
            @current-change="getUsers"
          />
        </el-tab-pane>
        <el-tab-pane label="公司" name="company">
          <el-row class="mb-2">
            <el-button type="primary" @click="handleAdd"  v-if="auth.user.role === 'province'"><i class="el-icon-plus" />新增</el-button>
            <el-cascader
              v-model="query.city"
              :props="{checkStrictly: true }"
              placeholder="请选择地区搜索"
              clearable
              :options="query.area ==='city' ? options.map(_option => {
                return {value: _option.value, label: _option.label}
              }) : options"
              @change="handleQueryCityChange"
            />
          </el-row>
          <el-table v-if="query.area==='company'" :key="timer" border :data="tableData">
            <el-table-column
              prop="nickname"
              width="250"
              label="名称"
            />
            <el-table-column
              prop="username"
              width="150"
              label="用户名"
            />
            <el-table-column
              prop="area"
              label="区域"
            />
            <el-table-column
              prop="company.capital"
              label="注册资金"
            />
            <el-table-column
              prop="company.internet"
              label="网络小贷"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.company.internet === 1">是</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="company.type"
              label="公司性质"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.company.type === 0">国有控股</el-tag>
                <el-tag v-else-if="scope.row.company.type === 1">民营控股</el-tag>
                <el-tag v-else-if="scope.row.company.type === 2">外资控股</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="company.manager"
              label="法人代表"
            />
            <el-table-column
              prop="company.reg_no"
              width="150"
              label="备案登记证号"
            />
            <el-table-column
              prop="company.usci"
              width="200"
              label="统一社会信用代码"
            />
            <el-table-column
              prop="company.admin_name"
              label="联系人"
            />
            <el-table-column
              prop="company.admin_phone"
              width="150"
              label="联系电话"
            />
            <el-table-column
              prop="created_at"
              width="160"
              label="添加时间"
            />
            <el-table-column width="150" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button type="text" @click="handleViewLog(scope.row)">日志</el-button>
                <el-button type="text" @click="handleStatus(scope.row)">{{ scope.row.status === 1 ? '启用' : '禁用' }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="query.page"
            :page-size="20"
            layout="total, prev, pager, next"
            :total="total"
            @current-change="getUsers"
          />
        </el-tab-pane>
      </el-tabs>

      <el-dialog :title="userForm.id > 0 ? '修改帐号' : '新增帐号'" :visible.sync="visible" :close-on-click-modal="false">
        <el-form ref="userForm" :model="userForm" :rules="rules" label-width="150px">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="userForm.username" />
            <div class="h-5 text-gray-400 text-sm">区县首字母缩写admin,地市名首字母缩写+区县名首字母缩写admin,公司为备案登记证号</div>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <div>
              <el-input v-model="userForm.name" />
              <div class="h-5 text-gray-400 text-sm">系统中显示的名字，区县xx管理员,公司为公司名</div>
            </div>
          </el-form-item>
          <el-form-item label="角色" prop="role">
            <el-select v-model="userForm.role">
              <el-option value="province" label="省管理员" />
              <el-option value="city" label="市州管理员" />
              <el-option value="district" label="区县管理员" />
              <el-option value="company" label="公司填报人" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="userForm.role !== 'province'" label="所在地区" prop="city">
            <el-cascader
              v-model="userForm.city"
              :options="userForm.role ==='city' ? options.map(_option => {
                return {value: _option.value, label: _option.label}
              }) : options"
            />
          </el-form-item>
          <el-form-item
            label="密码" prop="password" :rules="userForm.id > 0 ? [] : [
              {required: true, message: '请输入密码', trigger: 'blur'},
              {min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur'},
            ]"
          >
            <el-input v-model="userForm.password" type="password" />
          </el-form-item>
          <el-form-item label="强制修改密码">
            <el-checkbox v-model="userForm.isnew" :true-label="1" :false-label="0" />
            <div class="h-5 text-gray-400 text-sm">勾选后用户登录后需要修改密码才能正常使用</div>
          </el-form-item>
          <template v-if="userForm.role === 'company'">
            <el-form-item label="注册资本金" prop="capital">
              <el-input v-model="userForm.capital">
                <template slot="suffix">万元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="网络小额贷款公司" prop="internet">
              <el-checkbox v-model="userForm.internet" :true-label="1" :false-label="0" />
            </el-form-item>
            <el-form-item label="公司性质" prop="type">
              <el-select v-model="userForm.type" placeholder="请选择公司性质">
                <el-option label="国有控股" :value="0" />
                <el-option label="民营控股" :value="1" />
                <el-option label="外资控股" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="备案登记证号" prop="reg_no">
              <el-input v-model="userForm.reg_no" />
            </el-form-item>
            <el-form-item label="营业执照信用编码" prop="license">
              <el-input v-model="userForm.license" />
            </el-form-item>
            <el-form-item label="统一社会信用代码" prop="usci">
              <el-input v-model="userForm.usci" />
            </el-form-item>
            <el-form-item label="法定代表人" prop="manager">
              <el-input v-model="userForm.manager" />
            </el-form-item>
            <el-form-item label="联系人" prop="admin_name">
              <el-input v-model="userForm.admin_name" />
            </el-form-item>
            <el-form-item label="联系电话" prop="admin_phone">
              <el-input v-model="userForm.admin_phone" />
            </el-form-item>
            <el-form-item>
              <template slot="label">
                <div>
                  <span>股权结构
                    <el-button type="text" icon="el-icon-plus" @click="userForm.sharehold.push({name: '', percent: ''})" /></span>
                </div>
              </template>
              <el-row v-for="(sharehold, index) in userForm.sharehold" :key="index">
                <el-col :span="10">
                  <span>股东:<el-input v-model="userForm.sharehold[index].name" style="width: 60%;" size="small" /></span>
                </el-col>
                <el-col :span="10">
                  占股比例:<el-input v-model="userForm.sharehold[index].percent" style="width: 60%;" size="small">
                    <template slot="suffix">%</template>
                  </el-input>
                </el-col>
                <el-col :span="2">
                  <el-button type="text" icon="el-icon-minus" @click="userForm.sharehold.splice(index, 1)" />
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="贷款余额" prop="init_loan_amount">
              <el-input v-model="userForm.init_loan_amount" type="number" />
            </el-form-item>
            <el-form-item label="逾期贷款余额" prop="init_overdue_loan_amount">
              <el-input v-model="userForm.init_overdue_loan_amount" type="number" />
            </el-form-item>
          </template>

          <el-form-item>
            <el-button type="primary" :loading="loading" @click="submitForm">
              {{
                userForm.id > 0 ? '修改' : '新增'
              }}
            </el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="操作日志" :visible.sync="logVisible" :close-on-click-modal="false">
        <el-table border :data="logTableData">
          <el-table-column
            prop="id"
            label="ID"
            width="50"
          />
          <el-table-column
            prop="user.nickname"
            label="操作人员"
          />
          <el-table-column
            label="修改内容"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <p v-for="(content, index) in scope.row.contents" :key="index">
                {{ content.name }}: {{ content.old }}->{{ content.new }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="created_at"
            label="操作时间"
          />
        </el-table>
        <el-pagination
          :current-page.sync="logQuery.page"
          :page-size="logQuery.size"
          layout="total, prev, pager, next"
          :total="logTotal"
          @current-change="getCompanyLogs"
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>

import Layout2 from '../../Shared/Layout2'
import axios from 'axios'
import {areas} from '../../utils'

export default {
  layout: Layout2,
  props: {
    auth: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {

    return {
      logTableData: [],
      // options: (function() {
      //   if (this.auth.user.role === window.AREA.PROVINCE) {
      //     return areas
      //   } else if (this.auth.user.role === 'city') {
      //     return areas.filter(i => i.value === this.auth.user.city)
      //   } else {
      //     let _areas = []
      //     areas.forEach(val => {
      //       if (val.value === this.auth.user.city) {
      //         val.children = val.children.filter(j => j.value === this.auth.user.district)
      //         _areas.push(val)
      //       }
      //     })
      //     return _areas
      //   }
      // })(),
      activeName: 'city',
      timer: Date.now(),
      loading: false,
      logVisible: false,
      visible: false,
      tableData: [],
      userForm: {
        name: '',
        username: '',
        password: '',
        city: [],
        role: '',
        capital: '',
        internet: 0,
        type: 0,
        reg_no: '',
        license: '',
        usci: '',
        manager: '',
        admin_name: '',
        admin_id: 0,
        admin_phone: '',
        init_loan_amount: '',
        init_overdue_loan_amount: '',
        sharehold: [],
      },
      total: 0,
      query: {
        area: this.auth.user.role === 'province' ? 'city' : (this.auth.user.role === 'city' ? 'district' : 'company'),
        page: 1,
        size: 20,
      },
      logTotal:0,
      logQuery: {
        company_id: 0,
        page: 1,
        size: 20,
      },
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
          {min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'},
        ],
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'},
        ],
        role: [
          {required: true, message: '请输入角色', trigger: 'blur'},
        ],
        city: [
          {required: true, message: '请选择地区', trigger: 'blur'},
        ],
        reg_no: [
          {required: true, message: '请输入备案登记证号', trigger: 'blur'},
          {min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'},
        ],
        admin_phone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {min: 5, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'},
        ],
        init_loan_amount: [
          {required: true, message: '请输入贷款余额', trigger: 'blur'},
        ],
        init_overdue_loan_amount: [
          {required: true, message: '请输入逾期贷款余额', trigger: 'blur'},
        ],
      },
    }
  },
  watch: {
    'userForm.city'(newValue) {
      console.log('userForm.city', newValue)
      var area = ''
      let city = null
      if (newValue.length > 0) {
        city = this.options.find(element => element.value === newValue[0])
        if (city) {
          area += city.label
        }
      }
      if (newValue.length > 1 && city) {
        let di = city.children.find(i => {
          return i.value === newValue[1]
        })
        if (di) {
          area += di.label
        }
      }
      this.userForm.area = area
      console.log('userForm.city', newValue, area, city)

    },
    // 'query.city'(newValue) {
    //   this.getUsers()
    // }
  },
  created() {
    this.getUsers()
  },
  computed: {
    options() {
      if (this.auth.user.role === window.AREA.PROVINCE) {
        return areas
      } else if (this.auth.user.role === window.AREA.CITY) {
        return areas.filter(i => i.value === this.auth.user.city)
      } else {
        let _areas = []
        areas.forEach(val => {
          if (val.value === this.auth.user.city) {
            val.children = val.children.filter(j => j.value === this.auth.user.district)
            _areas.push(val)
          }
        })
        return _areas
      }
    }
  },
  methods: {
    handleQueryCityChange() {
      // this.query.area = area
      this.query.page = 1
      this.getUsers()
    },
    getUsers() {
      axios.post('/users', this.query).then(res => {
        // console.log(res)
        this.tableData = res.data.list
        this.loading = false
        this.total = res.data.total
      })
    },

    getCompanyLogs() {
      axios.post('/company/logs', this.logQuery).then(res => {
        // console.log(res)
        this.logTableData = res.data.list
        this.logTotal = res.data.total
      })
    },
    handleAdd() {
      this.visible = true
      this.userForm = {
        name: '',
        username: '',
        password: '',
        city: [],
        area: '',
        role: this.query.area,
        capital: '',
        internet: 0,
        type: 0,
        reg_no: '',
        license: '',
        usci: '',
        est: '',
        manager: '',
        admin_name: '',
        admin_id: 0,
        admin_phone: '',
        init_loan_amount: '',
        init_overdue_loan_amount: '',
      }
      this.$nextTick(() => {
        this.$refs['userForm'].clearValidate()
      })
    },
    submitForm() {
      console.log(this.userForm)
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          this.loading = true
          axios.post('/user/save', this.userForm).then((res) => {
            if (res.data.code === 0) {
              this.$message.success(this.userForm.id > 0 ? '修改成功' : '新增成功')
              this.visible = false
              this.getUsers()
            } else {
              this.$message.error(res.data.message)
            }
            this.loading = false
          }).catch(err => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.userForm = {
        name: '',
        username: '',
        password: '',
        city: [],
        role: this.query.area,
        capital: '',
        internet: 0,
        type: 0,
        reg_no: '',
        license: '',
        usci: '',
        manager: '',
        admin_name: '',
        admin_id: 0,
        admin_phone: '',
        init_loan_amount: '',
        init_overdue_loan_amount: '',
      }
      this.$refs['userForm'].clearValidate()
    },
    handleTabClick() {
      this.query.city = []
      this.query.page = 1
      this.tableData = []
      this.getUsers()
    },
    handleViewLog(row) {
      this.logQuery = {
        company_id: row.company.id,
        page: 1,
        size: 4
      }
      console.log(this.logQuery)
      this.logVisible = true
      this.getCompanyLogs()
    },
    handleEdit(row) {
      this.visible = true
      var city = []
      if (row.city) {
        city.push(row.city)
      }
      if (row.district) {
        city.push(row.district)
      }
      var form = {
        id: row.id,
        name: row.nickname,
        username: row.username,
        password: '',
        city: city,
        ares: row.area,
        role: row.role,
        isnew: row.isnew,
      }
      if (row.role === 'company' && row.company) {
        form = Object.assign(row.company, form)
      }
      this.userForm = _.cloneDeep(form)
    },
    handleStatus(row) {
      this.$confirm(row.block === 0 ? '确认禁用该用户？禁用后将无法登录' : '确认启用该用户？')
        .then(_ => {
          axios.post('/user/status', {id: row.id, status: row.block === 0 ? 1 : 0}).then((res) => {
            if (res.data.code === 0) {
              this.$message.success('修改成功')
              this.visible = false
              this.getUsers()
            } else {
              this.$message.error(res.data.message)
            }
            this.loading = false
          }).catch(err => {
            this.loading = false
          })
        })
        .catch(_ => {})

    },
    tableRowClassName({row, rowIndex}) {
      if (row.block === 1) {
        return 'disabled'
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-table .disabled {
  color: darkgray;
}
</style>

